'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _isArray2 = require('lodash/isArray');

var _isArray3 = _interopRequireDefault(_isArray2);

var _mapValues2 = require('lodash/mapValues');

var _mapValues3 = _interopRequireDefault(_mapValues2);

var _merge2 = require('lodash/merge');

var _merge3 = _interopRequireDefault(_merge2);

var _isPlainObject2 = require('lodash/isPlainObject');

var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);

var _forEach2 = require('lodash/forEach');

var _forEach3 = _interopRequireDefault(_forEach2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** Ensure consistent value format */
function toProps(value) {
  return (0, _isPlainObject3.default)(value) ? value : { value: value };
}

/**
 * Basic Enum constructor to provide some consistency to how we
 * define enums with associated properties
 */

var Enum = function () {
  function Enum(spec) {
    var _this = this;

    (0, _classCallCheck3.default)(this, Enum);
    this.properties = {};
    this.values = [];

    (0, _forEach3.default)(spec, function (value, keyOrIndex) {
      var properties = toProps(value);
      if (_this.properties[properties.value]) {
        throw new Error('Duplicate values (' + JSON.stringify(value) + ') found in enum spec. ');
      }
      var key = (0, _isArray3.default)(spec) ? value : keyOrIndex;
      _this[key] = properties.value;
      _this.values.push(properties.value);
      _this.properties[properties.value] = (0, _extends3.default)({}, properties);
    });
  }

  (0, _createClass3.default)(Enum, [{
    key: Symbol.iterator,
    value: /*#__PURE__*/_regenerator2.default.mark(function value() {
      return _regenerator2.default.wrap(function value$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.delegateYield(this.values, 't0', 1);

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, value, this);
    })

    /** https://github.com/Alexoner/react-redux-universal-hot-example/commit/8f357cccdaffbbcb51e46e6df5235dfd214db4e1 */

  }, {
    key: '__EMPTY_METHOD_WHICH_FIXES_BABEL_V8_BUG__',
    value: function __EMPTY_METHOD_WHICH_FIXES_BABEL_V8_BUG__() {}

    /**
     * Create an enum with values from difference source
     * - Useful for creating property objects from external schemas
     */

  }], [{
    key: 'withValues',
    value: function withValues(values, spec) {
      return new Enum((0, _merge3.default)({}, (0, _mapValues3.default)(values, toProps), spec));
    }
  }]);
  return Enum;
}();

exports.default = Enum;


//////////////////
// WEBPACK FOOTER
// ./~/@kalo/ui/lib/utils/enum.js
// module id = 83
// module chunks = 114276838955818